import createReducer from '../utils/createReducer';
import actions from '../actions/mailingInformation';
import {getComponentState} from '../utils/localStorageDataHandler';
import {checkMailingAddressBtnStatus} from '../utils/validate';

const initialState = {};

const actionHandlers = {
    [actions.GET_MAILING_METADATA_SUCCESS](state, {payload}) {
        return {
            ...state,
            mailingMetadata: payload.mailingMetadata
        };
    },

    [actions.SET_ADDRESS_FIELD](state, {payload}) {
        const {fieldName, fieldValue, addressType} = payload;
        let addressField = {};

        switch (fieldName) {
            case `${addressType}_country`:
                addressField[`${addressType}Country`] = fieldValue;
                addressField[`${addressType}State`] = '';
                break;

            case `${addressType}_address1`:
                addressField[`${addressType}AddressLine1`] = fieldValue;
                break;

            case `${addressType}_address2`:
                addressField[`${addressType}AddressLine2`] = fieldValue;
                break;

            case `${addressType}_city`:
                addressField[`${addressType}City`] = fieldValue;
                break;

            case `${addressType}_stateProvince`:
                addressField[`${addressType}State`] = fieldValue;
                break;

            case `${addressType}_postalCode`:
                addressField[`${addressType}PostalCode`] = fieldValue;
                break;

            default:
                break;
        }

        return {
            ...state,
            ...addressField
        }
    },

    [actions.SET_FIELD_ERROR](state, {payload}) {
        const {fieldName, errorMsg, addressType} = payload;
        const addressFiledError = {};

        switch (fieldName) {
            case `${addressType}_country`:
                addressFiledError[`${addressType}CountryError`] = errorMsg;
                break;

            case `${addressType}_address1`:
                addressFiledError[`${addressType}AddressLine1Error`] = errorMsg;
                break;

            case `${addressType}_city`:
                addressFiledError[`${addressType}CityError`] = errorMsg;
                break;

            case `${addressType}_stateProvince`:
                addressFiledError[`${addressType}StateError`] = errorMsg;
                break;

            case `${addressType}_postalCode`:
                addressFiledError[`${addressType}PostalCodeError`] = errorMsg;
                break;
            default:
                break;
        }

        return {
            ...state,
            ...addressFiledError
        };
    },

    [actions.ENABLE_MAILING_PG_CONTINUE_BUTTON](state, {}) {
        return {
            ...state,
            enableContinueButton: checkMailingAddressBtnStatus(state)
        };
    },

    [actions.MAILING_SERVICE_ERROR](state, {payload}) {
        return {
            ...state,
            serviceError: payload.errorKey
        };
    },

    [actions.PRE_POPULATE_LOCAL_STATE_MAILING](state, {payload}) {
        const stateData = getComponentState(payload.publicUuid, 'mailingInformation');

        if (stateData && stateData.state) {
            state = stateData.state;
        }

        return {
            ...state
        };
    },

    [actions.ADDRESS_CHOICE](state, {payload}) {
        const {
            mailingCountry,
            mailingAddressLine1,
            mailingAddressLine2,
            mailingCity,
            mailingState,
            mailingPostalCode
        } = state;

        let billingCountry;
        let billingAddressLine1;
        let billingAddressLine2;
        let billingCity;
        let billingState;
        let billingPostalCode;
        let enableContinueButton = false;

        if (payload.fieldValue === 'Mailing address') {
            billingCountry = mailingCountry;
            billingAddressLine1 = mailingAddressLine1;
            billingAddressLine2 = mailingAddressLine2;
            billingCity = mailingCity;
            billingState = mailingState;
            billingPostalCode = mailingPostalCode;
            enableContinueButton = checkMailingAddressBtnStatus(state);
        }

        return {
            ...state,
            billingCountry,
            billingAddressLine1,
            billingAddressLine2,
            billingCity,
            billingState,
            billingPostalCode,
            enableContinueButton,
            addressChoice: payload.fieldValue,
            countryError: '',
            addressLine1Error: '',
            cityError: '',
            stateError: '',
            postalCodeError: ''
        };
    },

    [actions.PRE_POPULATE_ADDRESSES_FROM_BILLING_SETUP_METADATA](state, {payload}) {
        let newState = {...state};

        const addresses = payload.addresses || [];
        const billingAddress = addresses.find((address) => address.addressType === "BILLING");
        let billingCountry;
        let billingAddressLine1;
        let billingAddressLine2;
        let billingCity;
        let billingState;
        let billingPostalCode;

        if (billingAddress) {
            const {
                country,
                address1,
                address2,
                stateProvince,
                city,
                postalCode
            } = billingAddress;

            billingCountry = country;
            billingAddressLine1 = address1;
            billingAddressLine2 = address2;
            billingCity = city;
            billingState = stateProvince;
            billingPostalCode = postalCode;
            newState = {
                ...newState,
                billingCountry,
                billingAddressLine1,
                billingAddressLine2,
                billingCity,
                billingState,
                billingPostalCode
            };
        }

        let mailingCountry;
        let mailingAddressLine1;
        let mailingAddressLine2;
        let mailingCity;
        let mailingState;
        let mailingPostalCode;

        const mailingAddress = addresses.find((address) => address.addressType === "CONTACT");
        if (mailingAddress) {
            const {
                country,
                address1,
                address2,
                stateProvince,
                city,
                postalCode
            } = mailingAddress;

            mailingCountry = country;
            mailingAddressLine1 = address1;
            mailingAddressLine2 = address2;
            mailingCity = city;
            mailingState = stateProvince;
            mailingPostalCode = postalCode;
            newState = {
                ...newState,
                mailingCountry,
                mailingAddressLine1,
                mailingAddressLine2,
                mailingCity,
                mailingState,
                mailingPostalCode
            };
        }


        return {
            ...newState,
            enableContinueButton: checkMailingAddressBtnStatus(newState)
        };
    }
};

export default createReducer(actionHandlers, initialState);
